import React, { useState } from "react";
import "./TriggerTranslation.css";

const TARGET_LANGUAGES = [
  "af", "am", "ar", "az", "be", "bg", "bn", "bs", "ca", "ceb", "co", "cs", "cy",
  "da", "de", "el", "en", "eo", "es", "et", "eu", "fa", "fi", "fr", "fy", "ga",
  "gd", "gl", "gu", "ha", "haw", "he", "hi", "hmn", "hr", "ht", "hu", "hy", "id",
  "ig", "is", "it", "ja", "jw", "ka", "kk", "km", "kn", "ko", "ku", "ky", "la",
  "lb", "lo", "lt", "lv", "mg", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my",
  "ne", "nl", "no", "ny", "pa", "pl", "ps", "pt", "ro", "ru", "rw", "sd", "si",
  "sk", "sl", "sm", "sn", "so", "sq", "sr", "st", "su", "sv", "sw", "ta", "te",
  "tg", "th", "tk", "tl", "tr", "tt", "ug", "uk", "ur", "uz", "vi", "xh", "yi",
  "yo", "zh", "zu",
];

const TriggerTranslation = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const handleTranslate = async () => {
    setLoading(true);
    setResult(null);
    setShowDetails(false);

    try {
      const response = await fetch(
        "https://api.malidag.com/translate/brand-media/auto-translate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            targetLanguages: TARGET_LANGUAGES,
            force: true,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || "Failed to trigger translation.");
      }

      setResult({
        type: "success",
        message: "Translation process started successfully.",
        data,
      });
    } catch (error) {
      console.error("Translation failed:", error);
      setResult({
        type: "error",
        message: error.message || "Failed to trigger translation.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="trigger-translation">
      <div className="trigger-translation__header">
        <h3 className="trigger-translation__title">Auto Translation</h3>
        <p className="trigger-translation__subtitle">
          Start automatic brand media translation for all supported languages.
        </p>
      </div>

      <div className="trigger-translation__actions">
        <button
          onClick={handleTranslate}
          disabled={loading}
          className="trigger-translation__button"
        >
          {loading ? "Translating..." : "Start Translation"}
        </button>

        <span className="trigger-translation__meta">
          {TARGET_LANGUAGES.length} languages
        </span>
      </div>

      {result && (
        <div
          className={`trigger-translation__result trigger-translation__result--${result.type}`}
        >
          <p className="trigger-translation__message">{result.message}</p>

          {result.data && (
            <>
              <button
                className="trigger-translation__details-btn"
                onClick={() => setShowDetails(!showDetails)}
              >
                {showDetails ? "Hide details" : "Show details"}
              </button>

              {showDetails && (
                <pre className="trigger-translation__details">
                  {JSON.stringify(result.data, null, 2)}
                </pre>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TriggerTranslation;